module.exports = __webpack_public_path__ + "static/facebook_icon-4019145022b924db2a2bf712a081dea4.png";